import type { SVGProps } from 'react';

export const YouTubeLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-170 -170 1340 1340" {...props}>
    <title>YouTube</title>
    <rect x="-170" y="-170" width="1340" height="1340" fill="#ee203b" />
    <path
      fill="white"
      d="M112.68 826.12c-42.71-11.58-76.01-45.61-88.32-87.59C4.09 661.07 4.09 499.64 4.09 499.64s0-161.43 20.27-238.16c12.31-42.71 45.61-76.01 88.32-87.59 76.73-20.99 386.56-20.99 386.56-20.99s310.55 0 387.28 20.99c43.43 11.58 76.01 44.88 87.59 87.59 20.99 76.73 20.99 238.16 20.99 238.16s0 161.43-20.99 238.89c-11.58 41.98-44.16 76.01-87.59 87.59-76.73 20.99-387.28 20.99-387.28 20.99s-309.83 0-386.56-20.99Zm288.1-177.36 256.99-149.12-256.99-148.4v297.52Z"
    />
  </svg>
);
